import { useEffect, useRef, useState } from "react";

export default function SobreMi() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="sobre-mi" className="py-24 bg-[#0a0a0f]" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center transition-all duration-1000 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          
          {/* Image Side */}
          <div className="relative flex justify-center lg:justify-start">
            <div className="relative">
              <div className="w-72 h-96 md:w-80 md:h-[480px] rounded-3xl overflow-hidden border-2 border-[#c9a84c]/30">
                <img
                  src="https://public.readdy.ai/ai/img_res/41dbfe7c5a0de3f5fa6345d4b80c7156.jpg"
                  alt="Albert Vidente Tarotista"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0f]/60 via-transparent to-transparent rounded-3xl"></div>
              </div>

              {/* Floating badges */}
              <div className="absolute -top-4 -right-4 bg-[#c9a84c] text-black px-4 py-2 rounded-full text-sm font-bold shadow-lg whitespace-nowrap">
                20+ años
              </div>
              <div className="absolute bottom-8 -left-6 bg-[#1a0a2e] border border-[#c9a84c]/40 text-white px-4 py-2 rounded-full text-xs font-medium whitespace-nowrap">
                <i className="ri-global-line mr-1 text-[#c9a84c]"></i>
                Consultas Online
              </div>
              <div className="absolute top-1/2 -right-8 bg-[#1a0a2e] border border-[#c9a84c]/40 text-white px-4 py-2 rounded-full text-xs font-medium whitespace-nowrap">
                <i className="ri-star-fill mr-1 text-[#c9a84c]"></i>
                5.000+ consultas
              </div>
            </div>
          </div>

          {/* Text Side */}
          <div>
            <p className="text-[#c9a84c] text-sm tracking-widest uppercase font-medium mb-4">Sobre mí</p>
            <h2 className="font-serif text-4xl md:text-5xl text-white font-bold mb-6 leading-tight">
              Conoce a <span className="text-[#c9a84c]">Albert</span>
            </h2>

            <div className="flex flex-wrap gap-2 mb-8">
              {["Tarot", "Videncia", "Astrología", "Guía Espiritual"].map((tag) => (
                <span key={tag} className="px-3 py-1 border border-[#c9a84c]/40 text-[#c9a84c] text-xs rounded-full">
                  {tag}
                </span>
              ))}
            </div>

            <p className="text-white/70 text-base leading-relaxed mb-6">
              Soy Albert, vidente y tarotista profesional con más de <strong className="text-white">15 años de experiencia</strong> guiando a personas en momentos cruciales de su vida. Mi don espiritual me permite conectar con energías superiores para ofrecerte mensajes claros y precisos.
            </p>
            <p className="text-white/70 text-base leading-relaxed mb-8">
              Trabajo de forma completamente <strong className="text-white">online</strong>, lo que me permite atender a clientes de todo el mundo. Cada consulta es única, personalizada y realizada con total confidencialidad y respeto. Mi misión es ayudarte a encontrar claridad, paz y dirección en tu camino de vida.
            </p>

            {/* Feature cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                { icon: "ri-shield-check-line", title: "Confidencialidad Total", desc: "Tus consultas son completamente privadas" },
                { icon: "ri-time-line", title: "Respuesta Rápida", desc: "Citas disponibles en menos de 24 horas" },
                { icon: "ri-global-line", title: "100% Online", desc: "Desde cualquier lugar del mundo" },
                { icon: "ri-heart-line", title: "Enfoque Humano", desc: "Con empatía, respeto y sin juicios" },
              ].map((item) => (
                <div key={item.title} className="flex items-start gap-3 p-4 bg-white/5 rounded-xl border border-white/10">
                  <div className="w-8 h-8 flex items-center justify-center text-[#c9a84c] flex-shrink-0">
                    <i className={`${item.icon} text-lg`}></i>
                  </div>
                  <div>
                    <p className="text-white text-sm font-semibold">{item.title}</p>
                    <p className="text-white/50 text-xs mt-0.5">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
